// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SortIcon_wrapper__xGdnr","text":"SortIcon_text___6QCh","icon":"SortIcon_icon__BXRJ6","faSortUp":"SortIcon_faSortUp__pDy06","faSortDown":"SortIcon_faSortDown__hTYbU"};